export default "__VITE_ASSET__VUfTVOV0__"